/*

Debounce zajišťuje, aby se při např. resize apod. eventech nespouštěl pokaždé.
https://davidwalsh.name/javascript-debounce-function

Použití:

window.addEventListener('resize', debounce(function() {}, 250));

*/
export default function(func, wait, immediate) {
  let timeout;

  return function() {
    let context = this, args = arguments;
    let later = function() {
      timeout = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};
